import { defineMessages } from 'react-intl';

import type { MessageDescriptor } from 'react-intl';

export const FreightGetHelpReasonCode = {
  LostShipment: '001',
  DamagedShipment: '002',
  BillingErrorShipment: '003',
  IncorrectDimensionsOrWeight: '004',
  InvalidAccessorialFee: '005',
  LateDelivery: '009',
} as const;
export type FreightGetHelpReasonCode = (typeof FreightGetHelpReasonCode)[keyof typeof FreightGetHelpReasonCode];

/** Array order IS the picker order. `satisfies` forces new reason-set declarations to use real codes. */
export const FREIGHT_GET_HELP_REASON_SETS = {
  freightShipment: ['001', '002', '003', '004', '005', '009'],
} as const satisfies Record<string, readonly FreightGetHelpReasonCode[]>;

const reasonMessages = defineMessages({
  lostShipment: {
    defaultMessage: 'Lost Shipment',
    id: '/EcFLC',
    description: 'Get Help reason: the shipment was lost in transit',
  },
  damagedShipment: {
    defaultMessage: 'Damaged Shipment',
    id: 'h6uY4L',
    description: 'Get Help reason: the shipment arrived damaged',
  },
  billingError: {
    defaultMessage: 'Billing Error',
    id: '7r89iR',
    description: 'Get Help reason: there is a billing error on the shipment',
  },
  incorrectDimensionsOrWeight: {
    defaultMessage: 'Incorrect Dimensions or Weight',
    id: 'zT4Mpo',
    description: 'Get Help reason: the shipment dimensions or weight were recorded incorrectly',
  },
  invalidAccessorialFee: {
    defaultMessage: 'Invalid Accessorial Fee',
    id: 'r4uJqd',
    description: 'Get Help reason: an accessorial fee was applied incorrectly',
  },
  lateDelivery: {
    defaultMessage: 'Late Delivery',
    id: 'x97ik1',
    description: 'Get Help reason: the shipment was delivered late',
  },
});

export type FreightGetHelpReason = {
  label: MessageDescriptor;
  /** Untranslated name sent to Zendesk — never intl.formatMessage this. */
  internalName: string;
};

export const FREIGHT_GET_HELP_REASONS: Record<FreightGetHelpReasonCode, FreightGetHelpReason> = {
  '001': { label: reasonMessages.lostShipment, internalName: 'Lost Shipment' },
  '002': { label: reasonMessages.damagedShipment, internalName: 'Damaged Shipment' },
  '003': { label: reasonMessages.billingError, internalName: 'Billing Error - Shipment' },
  '004': { label: reasonMessages.incorrectDimensionsOrWeight, internalName: 'Incorrect Dimensions or Weight' },
  '005': { label: reasonMessages.invalidAccessorialFee, internalName: 'Invalid Accessorial Fee' },
  '009': { label: reasonMessages.lateDelivery, internalName: 'Late Delivery' },
};
